import React from "react";
import PropTypes from "prop-types";
import getConfig from "next/config";
import Link from "next/link";
import { useRouter } from "next/router";
import classNames from "classnames";

import BreadcrumbSchema from "@components/BreadcrumbSchema";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const isBricoStore = settings.websiteName === "bricostore";

const Breadcrumbs = ({ breadcrumbs, isPDP = false, className }) => {
  const router = useRouter();

  return (
    <>
      {breadcrumbs && (
        <BreadcrumbSchema
          breadcrumbData={breadcrumbs}
          currentPath={router.asPath}
        />
      )}

      {/* is-hidden-in-mobile-app class is used to hide this content in the WebView used for support and contact sections in mobile app */}
      <div
        className={`Breadcrumbs is-hidden-in-mobile-app pb-3 lg:py-3 truncate text-sm ${className}`}
      >
        <ol className="p-0 m-0 list-none inline">
          {breadcrumbs.map((breadcrumb, index) =>
            breadcrumb.level != 99 ? (
              <li
                key={`${breadcrumb.level}-${breadcrumb.id}-${index}`}
                className={classNames("inline", {
                  "text-red-brand": isBricoStore || !isPDP,
                  "text-[#1D4ED8]": !isBricoStore && isPDP,
                })}
              >
                <Link
                  href={`${settings.baseUrl}/${breadcrumb.url_key}${
                    breadcrumb.url_suffix || ""
                  }`}
                >
                  <a
                    title={breadcrumb.name}
                    className={classNames({
                      // "text-red-brand": !isBricoStore,
                      // "text-bleu": isBricoStore,
                    })}
                  >
                    {breadcrumb.name}
                  </a>
                </Link>
                <span className="mx-1">/</span>
              </li>
            ) : (
              <li
                key={`${breadcrumb.level}-${breadcrumb.id}-${index}`}
                className="inline"
              >
                {breadcrumb.name}
              </li>
            )
          )}
        </ol>
      </div>
    </>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      level: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url_key: (props, propName) => {
        if (
          props["level"] !== 99 &&
          (typeof props[propName] !== "string" || props[propName].length === 0)
        ) {
          return new Error("Please provide url_key when item level is not 99.");
        }
      },
      url_suffix: PropTypes.string,
    })
  ).isRequired,
};

export default Breadcrumbs;
